import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { key: String }

  connect() {
    const stored = localStorage.getItem(this.storageKey)
    if (stored === "true") {
      this.element.open = true
    }
  }

  toggle() {
    localStorage.setItem(this.storageKey, this.element.open)
  }

  get storageKey() {
    return `collapsible-${this.keyValue}`
  }
}
